<template>
  <div>
    <Table :columns="columns" :data="tableData"></Table>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
export default {
  mixins: [common, pageTool],
  data() {
    return {
      columns: [
        {
          title: '加扣款名称',
          align: 'center',
          key: 'deductionName',
          minWidth: 120
        },
        {
          title: '加扣款金额(税前)',
          align: 'center',
          key: 'deduction',
          minWidth: 120
        }
      ],
      tableData: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let data = {
        reportId: this.$route.query.reportId,
        type: 11,
        userId: this.$route.query.userId,
        pageSize: this.pageSize,
        pageNo: this.pageNum
      };
      this.$http({
        url: '/buz/userSalaryDetails/getDetailWithSelf',
        type: 'POST',
        data
      }).then(res => {
        this.tableData = res.data;
        this.total = res.total;
        this.$emit('showTable', this.total == 0 ? false : true, 11);
      });
    }
  }
};
</script>

<style></style>
